import { render, staticRenderFns } from "./PayToProvider.vue?vue&type=template&id=425b7d37"
import script from "./PayToProvider.vue?vue&type=script&lang=js"
export * from "./PayToProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports